(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".red-placeholder::placeholder{color:#c2c2c5!important}")),document.head.appendChild(e)}}catch(c){console.error("vite-plugin-css-injected-by-js",c)}})();
import Tt, { createContext as rt, useContext as Pt, useState as ze, useEffect as fe, useMemo as nt, forwardRef as te } from "react";
import { gql as Oe, useMutation as wr, useQuery as St, useApolloClient as Ie } from "@apollo/client";
import kr from "axios";
import { jsx as y, jsxs as U } from "react/jsx-runtime";
import "@mui/material/styles";
import { Tooltip as Cr, TextField as jr, InputAdornment as Er, IconButton as Rt, FormLabel as Tr, Typography as gt, Divider as Pr } from "@mui/material";
import { useTranslation as Ne } from "react-i18next";
const ge = {
  openProjectCreateDialogEventApiV2: "project-create-dialog-open-event-api-v2",
  projectCreateDialogProjectCreatedEvent: "project-create-dialog-project-created-event"
};
function Sr(t) {
  window.dispatchEvent(
    new CustomEvent(
      ge.openProjectCreateDialogEventApiV2,
      {
        detail: t
      }
    )
  );
}
const Rr = "set-current-project-id", Da = ge.projectCreateDialogProjectCreatedEvent, Or = {
  createProjectSubmitButton: "submit-create-project-button",
  showCreateProjectDialogButton: "show-create-project-button"
}, Ir = ({
  element: t,
  identifier: e,
  prefix: r
}) => ({
  "data-selector": `${r ? `${r}-` : ""}${t}`,
  ...e && { id: `${t}-${e}` }
});
function Nr(t) {
  const e = rt(t), r = () => {
    const n = Pt(e);
    if (n === void 0)
      throw new Error(
        "Context is attempting to be consumed outside of its provider."
      );
    return n;
  };
  return {
    Provider: e.Provider,
    useContext: r
  };
}
var me = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ar(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Mr(t) {
  const e = Object.fromEntries(
    document.cookie.split("; ").map((r) => r.split("="))
  );
  return e[t] ? decodeURIComponent(e[t]) : null;
}
const Dr = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, $r = () => {
  const t = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return Dr[t];
};
var ae = { exports: {} };
ae.exports;
var vt;
function Lr() {
  return vt || (vt = 1, (function(t, e) {
    var r = 9007199254740991, n = "[object Arguments]", a = "[object Function]", s = "[object GeneratorFunction]", i = "[object Map]", o = "[object Object]", d = "[object Promise]", c = "[object Set]", m = "[object WeakMap]", C = "[object DataView]", F = /[\\^$.*+?()[\]{}|]/g, re = /^\[object .+?Constructor\]$/, Gt = typeof me == "object" && me && me.Object === Object && me, Yt = typeof self == "object" && self && self.Object === Object && self, z = Gt || Yt || Function("return this")(), it = e && !e.nodeType && e, ot = it && !0 && t && !t.nodeType && t, Ht = ot && ot.exports === it;
    function Jt(l, w) {
      return l?.[w];
    }
    function Qt(l) {
      var w = !1;
      if (l != null && typeof l.toString != "function")
        try {
          w = !!(l + "");
        } catch {
        }
      return w;
    }
    function Xt(l, w) {
      return function(S) {
        return l(w(S));
      };
    }
    var er = Function.prototype, he = Object.prototype, De = z["__core-js_shared__"], ct = (function() {
      var l = /[^.]+$/.exec(De && De.keys && De.keys.IE_PROTO || "");
      return l ? "Symbol(src)_1." + l : "";
    })(), dt = er.toString, $e = he.hasOwnProperty, pe = he.toString, tr = RegExp(
      "^" + dt.call($e).replace(F, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), ut = Ht ? z.Buffer : void 0, lt = he.propertyIsEnumerable, rr = ut ? ut.isBuffer : void 0, nr = Xt(Object.keys, Object), Le = ne(z, "DataView"), Ze = ne(z, "Map"), Ue = ne(z, "Promise"), Ve = ne(z, "Set"), Be = ne(z, "WeakMap"), ar = !lt.call({ valueOf: 1 }, "valueOf"), sr = K(Le), ir = K(Ze), or = K(Ue), cr = K(Ve), dr = K(Be);
    function ur(l) {
      return pe.call(l);
    }
    function lr(l) {
      if (!pt(l) || fr(l))
        return !1;
      var w = ht(l) || Qt(l) ? tr : re;
      return w.test(K(l));
    }
    function ne(l, w) {
      var S = Jt(l, w);
      return lr(S) ? S : void 0;
    }
    var W = ur;
    (Le && W(new Le(new ArrayBuffer(1))) != C || Ze && W(new Ze()) != i || Ue && W(Ue.resolve()) != d || Ve && W(new Ve()) != c || Be && W(new Be()) != m) && (W = function(l) {
      var w = pe.call(l), S = w == o ? l.constructor : void 0, mt = S ? K(S) : void 0;
      if (mt)
        switch (mt) {
          case sr:
            return C;
          case ir:
            return i;
          case or:
            return d;
          case cr:
            return c;
          case dr:
            return m;
        }
      return w;
    });
    function fr(l) {
      return !!ct && ct in l;
    }
    function hr(l) {
      var w = l && l.constructor, S = typeof w == "function" && w.prototype || he;
      return l === S;
    }
    function K(l) {
      if (l != null) {
        try {
          return dt.call(l);
        } catch {
        }
        try {
          return l + "";
        } catch {
        }
      }
      return "";
    }
    function pr(l) {
      return gr(l) && $e.call(l, "callee") && (!lt.call(l, "callee") || pe.call(l) == n);
    }
    var mr = Array.isArray;
    function ft(l) {
      return l != null && _r(l.length) && !ht(l);
    }
    function gr(l) {
      return xr(l) && ft(l);
    }
    var vr = rr || br;
    function yr(l) {
      if (ft(l) && (mr(l) || typeof l == "string" || typeof l.splice == "function" || vr(l) || pr(l)))
        return !l.length;
      var w = W(l);
      if (w == i || w == c)
        return !l.size;
      if (ar || hr(l))
        return !nr(l).length;
      for (var S in l)
        if ($e.call(l, S))
          return !1;
      return !0;
    }
    function ht(l) {
      var w = pt(l) ? pe.call(l) : "";
      return w == a || w == s;
    }
    function _r(l) {
      return typeof l == "number" && l > -1 && l % 1 == 0 && l <= r;
    }
    function pt(l) {
      var w = typeof l;
      return !!l && (w == "object" || w == "function");
    }
    function xr(l) {
      return !!l && typeof l == "object";
    }
    function br() {
      return !1;
    }
    t.exports = yr;
  })(ae, ae.exports)), ae.exports;
}
var Zr = Lr();
const Ur = /* @__PURE__ */ Ar(Zr);
function Vr(t) {
  return Ur(t);
}
const Br = (t, e) => window.localStorage.setItem(t, e), Fr = (t) => window.localStorage.getItem(t), zr = (t) => window.localStorage.removeItem(t), Wr = {
  setItem: Br,
  getItem: Fr,
  removeItem: zr
};
function $a() {
  return { analyticsProps: Ir({
    element: Or.showCreateProjectDialogButton
  }) };
}
function La() {
  function t(e) {
    Sr(e);
  }
  return { onCreate: t };
}
var Ot = /* @__PURE__ */ ((t) => (t.Asc = "ASC", t.Desc = "DESC", t))(Ot || {}), Z = /* @__PURE__ */ ((t) => (t.Active = "ACTIVE", t.OnHold = "ON_HOLD", t.Completed = "COMPLETED", t.Canceled = "CANCELED", t.Archived = "ARCHIVED", t))(Z || {}), E = /* @__PURE__ */ ((t) => (t.January = "JANUARY", t.February = "FEBRUARY", t.March = "MARCH", t.April = "APRIL", t.May = "MAY", t.June = "JUNE", t.July = "JULY", t.August = "AUGUST", t.September = "SEPTEMBER", t.October = "OCTOBER", t.November = "NOVEMBER", t.December = "DECEMBER", t.NotSure = "NOT_SURE", t))(E || {});
const Kr = {
  setUserCurrentProject: "sdg_project/project/projectssetlist"
}, O = Oe`
  fragment ProjectFragment on Project {
    id
    title
    country {
      code
      name
    }
    state {
      code
      name
    }
    city
    createdAt
    updatedAt
    externalId
    status
    userRef
    phase {
      code
      label
    }
    details
    type {
      code
      label
      externalId
    }
    budget {
      from
      to
      unit
    }
    size {
      from
      to
      unit
    }
    dueMonth
    dueYear
  }
`, qr = kr.create(), Gr = {
  appDataStorageKey: "mage-cache-storage"
}, Yr = "en", It = ENVIRONMENT_REGION ?? "US", yt = "private-content-loaded";
function Hr(t, e) {
  return qr(`/${t}`, {
    ...e,
    baseURL: "",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept-Language": $r() || Yr,
      ...e?.headers
    }
  });
}
const { appDataStorageKey: Jr } = Gr;
function Qr() {
  return JSON.parse(Wr.getItem(Jr) || "{}")?.customer || {};
}
const Xr = "reload-customer-section-data";
function en() {
  window.dispatchEvent(new CustomEvent(Xr));
}
var Nt = /* @__PURE__ */ ((t) => (t[t.TIER_1_GROUP_ID = 1] = "TIER_1_GROUP_ID", t[t.TIER_2_GROUP_ID = 2] = "TIER_2_GROUP_ID", t[t.TIER_3_GROUP_ID = 3] = "TIER_3_GROUP_ID", t[t.TIER_5_GROUP_ID = 5] = "TIER_5_GROUP_ID", t[t.TIER_8_GROUP_ID = 8] = "TIER_8_GROUP_ID", t[t.TIER_10_GROUP_ID = 10] = "TIER_10_GROUP_ID", t[t.TIER_0_GROUP_ID = 11] = "TIER_0_GROUP_ID", t[t.TIER_7_GROUP_ID = 12] = "TIER_7_GROUP_ID", t[t.TIER_13_GROUP_ID = 13] = "TIER_13_GROUP_ID", t[t.TIER_99_GROUP_ID = 14] = "TIER_99_GROUP_ID", t[t.TIER_9_GROUP_ID = 15] = "TIER_9_GROUP_ID", t[t.TIER_15_GROUP_ID = 16] = "TIER_15_GROUP_ID", t[t.TIER_16_GROUP_ID = 17] = "TIER_16_GROUP_ID", t[t.TIER_MCX_GROUP_ID = 21] = "TIER_MCX_GROUP_ID", t[t.TIER_400_GROUP_ID = 22] = "TIER_400_GROUP_ID", t))(Nt || {}), b;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, t.getValidEnumValues = (a) => {
    const s = t.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return t.objectValues(i);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(s) {
    return a[s];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, t.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(b || (b = {}));
var _t;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(_t || (_t = {}));
const h = b.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), q = (t) => {
  switch (typeof t) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return isNaN(t) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(t) ? h.array : t === null ? h.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? h.promise : typeof Map < "u" && t instanceof Map ? h.map : typeof Set < "u" && t instanceof Set ? h.set : typeof Date < "u" && t instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, u = b.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class R extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, d = 0;
          for (; d < i.path.length; ) {
            const c = i.path[d];
            d === i.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(r(i))) : o[c] = o[c] || { _errors: [] }, o = o[c], d++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof R))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
R.create = (t) => new R(t);
const de = (t, e) => {
  let r;
  switch (t.code) {
    case u.invalid_type:
      t.received === h.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case u.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, b.jsonStringifyReplacer)}`;
      break;
    case u.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${b.joinValues(t.keys, ", ")}`;
      break;
    case u.invalid_union:
      r = "Invalid input";
      break;
    case u.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${b.joinValues(t.options)}`;
      break;
    case u.invalid_enum_value:
      r = `Invalid enum value. Expected ${b.joinValues(t.options)}, received '${t.received}'`;
      break;
    case u.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case u.invalid_return_type:
      r = "Invalid function return type";
      break;
    case u.invalid_date:
      r = "Invalid date";
      break;
    case u.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : b.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case u.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case u.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case u.custom:
      r = "Invalid input";
      break;
    case u.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case u.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case u.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, b.assertNever(t);
  }
  return { message: r };
};
let tn = de;
function We() {
  return tn;
}
const Ke = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const d = n.filter((c) => !!c).slice().reverse();
  for (const c of d)
    o = c(i, { data: e, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function f(t, e) {
  const r = We(), n = Ke({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      r,
      r === de ? void 0 : de
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
class T {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return v;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return T.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return v;
      s.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const v = Object.freeze({
  status: "aborted"
}), se = (t) => ({ status: "dirty", value: t }), P = (t) => ({ status: "valid", value: t }), xt = (t) => t.status === "aborted", bt = (t) => t.status === "dirty", ve = (t) => t.status === "valid", ye = (t) => typeof Promise < "u" && t instanceof Promise;
function _e(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function At(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var p;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(p || (p = {}));
var ie, oe;
class A {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wt = (t, e) => {
  if (ve(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new R(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function _(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (i, o) => {
    var d, c;
    const { message: m } = t;
    return i.code === "invalid_enum_value" ? { message: m ?? o.defaultError } : typeof o.data > "u" ? { message: (d = m ?? n) !== null && d !== void 0 ? d : o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: (c = m ?? r) !== null && c !== void 0 ? c : o.defaultError };
  }, description: a };
}
class x {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return q(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: q(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new T(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: q(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (ye(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r?.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: q(e)
    }, s = this._parseSync({ data: e, path: a.path, parent: a });
    return wt(a, s);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: q(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), s = await (ye(a) ? a : Promise.resolve(a));
    return wt(n, s);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = e(a), o = () => s.addIssue({
        code: u.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((d) => d ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new L({
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return N.create(this, this._def);
  }
  nullable() {
    return B.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return I.create(this, this._def);
  }
  promise() {
    return le.create(this, this._def);
  }
  or(e) {
    return we.create([this, e], this._def);
  }
  and(e) {
    return ke.create(this, e, this._def);
  }
  transform(e) {
    return new L({
      ..._(this._def),
      schema: this,
      typeName: g.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Pe({
      ..._(this._def),
      innerType: this,
      defaultValue: r,
      typeName: g.ZodDefault
    });
  }
  brand() {
    return new Lt({
      typeName: g.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Se({
      ..._(this._def),
      innerType: this,
      catchValue: r,
      typeName: g.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Ae.create(this, e);
  }
  readonly() {
    return Re.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const rn = /^c[^\s-]{8,}$/i, nn = /^[0-9a-z]+$/, an = /^[0-9A-HJKMNP-TV-Z]{26}$/, sn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, on = /^[a-z0-9_-]{21}$/i, cn = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, dn = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, un = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Fe;
const ln = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, fn = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, hn = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Mt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", pn = new RegExp(`^${Mt}$`);
function Dt(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function mn(t) {
  return new RegExp(`^${Dt(t)}$`);
}
function gn(t) {
  let e = `${Mt}T${Dt(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function vn(t, e) {
  return !!((e === "v4" || !e) && ln.test(t) || (e === "v6" || !e) && fn.test(t));
}
class D extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== h.string) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: u.invalid_type,
        expected: h.string,
        received: s.parsedType
      }), v;
    }
    const n = new T();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (a = this._getOrReturnCtx(e, a), f(a, {
          code: u.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (a = this._getOrReturnCtx(e, a), f(a, {
          code: u.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = e.data.length > s.value, o = e.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(e, a), i ? f(a, {
          code: u.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && f(a, {
          code: u.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        dn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "email",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Fe || (Fe = new RegExp(un, "u")), Fe.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "emoji",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        sn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "uuid",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        on.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "nanoid",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        rn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "cuid",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        nn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "cuid2",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        an.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
          validation: "ulid",
          code: u.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), f(a, {
            validation: "url",
            code: u.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        validation: "regex",
        code: u.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? gn(s).test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? pn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? mn(s).test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? cn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        validation: "duration",
        code: u.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? vn(e.data, s.version) || (a = this._getOrReturnCtx(e, a), f(a, {
        validation: "ip",
        code: u.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? hn.test(e.data) || (a = this._getOrReturnCtx(e, a), f(a, {
        validation: "base64",
        code: u.invalid_string,
        message: s.message
      }), n.dirty()) : b.assertNever(s);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: u.invalid_string,
      ...p.errToObj(n)
    });
  }
  _addCheck(e) {
    return new D({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (r = e?.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e?.local) !== null && n !== void 0 ? n : !1,
      ...p.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...p.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r?.position,
      ...p.errToObj(r?.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, p.errToObj(e));
  }
  trim() {
    return new D({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new D({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new D({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
D.create = (t) => {
  var e;
  return new D({
    checks: [],
    typeName: g.ZodString,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(t)
  });
};
function yn(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, s = parseInt(t.toFixed(a).replace(".", "")), i = parseInt(e.toFixed(a).replace(".", ""));
  return s % i / Math.pow(10, a);
}
class Q extends x {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== h.number) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: u.invalid_type,
        expected: h.number,
        received: s.parsedType
      }), v;
    }
    let n;
    const a = new T();
    for (const s of this._def.checks)
      s.kind === "int" ? b.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? yn(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.not_finite,
        message: s.message
      }), a.dirty()) : b.assertNever(s);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Q({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
Q.create = (t) => new Q({
  checks: [],
  typeName: g.ZodNumber,
  coerce: t?.coerce || !1,
  ..._(t)
});
class X extends x {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== h.bigint) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: u.invalid_type,
        expected: h.bigint,
        received: s.parsedType
      }), v;
    }
    let n;
    const a = new T();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), f(n, {
        code: u.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : b.assertNever(s);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, a) {
    return new X({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new X({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
X.create = (t) => {
  var e;
  return new X({
    checks: [],
    typeName: g.ZodBigInt,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(t)
  });
};
class qe extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== h.boolean) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.boolean,
        received: n.parsedType
      }), v;
    }
    return P(e.data);
  }
}
qe.create = (t) => new qe({
  typeName: g.ZodBoolean,
  coerce: t?.coerce || !1,
  ..._(t)
});
class ue extends x {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== h.date) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: u.invalid_type,
        expected: h.date,
        received: s.parsedType
      }), v;
    }
    if (isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: u.invalid_date
      }), v;
    }
    const n = new T();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (a = this._getOrReturnCtx(e, a), f(a, {
        code: u.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : b.assertNever(s);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ue({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
ue.create = (t) => new ue({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: g.ZodDate,
  ..._(t)
});
class Ge extends x {
  _parse(e) {
    if (this._getType(e) !== h.symbol) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.symbol,
        received: n.parsedType
      }), v;
    }
    return P(e.data);
  }
}
Ge.create = (t) => new Ge({
  typeName: g.ZodSymbol,
  ..._(t)
});
class xe extends x {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.undefined,
        received: n.parsedType
      }), v;
    }
    return P(e.data);
  }
}
xe.create = (t) => new xe({
  typeName: g.ZodUndefined,
  ..._(t)
});
class be extends x {
  _parse(e) {
    if (this._getType(e) !== h.null) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.null,
        received: n.parsedType
      }), v;
    }
    return P(e.data);
  }
}
be.create = (t) => new be({
  typeName: g.ZodNull,
  ..._(t)
});
class Ye extends x {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return P(e.data);
  }
}
Ye.create = (t) => new Ye({
  typeName: g.ZodAny,
  ..._(t)
});
class H extends x {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return P(e.data);
  }
}
H.create = (t) => new H({
  typeName: g.ZodUnknown,
  ..._(t)
});
class V extends x {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return f(r, {
      code: u.invalid_type,
      expected: h.never,
      received: r.parsedType
    }), v;
  }
}
V.create = (t) => new V({
  typeName: g.ZodNever,
  ..._(t)
});
class He extends x {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.void,
        received: n.parsedType
      }), v;
    }
    return P(e.data);
  }
}
He.create = (t) => new He({
  typeName: g.ZodVoid,
  ..._(t)
});
class I extends x {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== h.array)
      return f(r, {
        code: u.invalid_type,
        expected: h.array,
        received: r.parsedType
      }), v;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (f(r, {
        code: i ? u.too_big : u.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (f(r, {
      code: u.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (f(r, {
      code: u.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new A(r, i, r.path, o)))).then((i) => T.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new A(r, i, r.path, o)));
    return T.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new I({
      ...this._def,
      minLength: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new I({
      ...this._def,
      maxLength: { value: e, message: p.toString(r) }
    });
  }
  length(e, r) {
    return new I({
      ...this._def,
      exactLength: { value: e, message: p.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
I.create = (t, e) => new I({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g.ZodArray,
  ..._(e)
});
function Y(t) {
  if (t instanceof k) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = N.create(Y(n));
    }
    return new k({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof I ? new I({
    ...t._def,
    type: Y(t.element)
  }) : t instanceof N ? N.create(Y(t.unwrap())) : t instanceof B ? B.create(Y(t.unwrap())) : t instanceof $ ? $.create(t.items.map((e) => Y(e))) : t;
}
class k extends x {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = b.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== h.object) {
      const c = this._getOrReturnCtx(e);
      return f(c, {
        code: u.invalid_type,
        expected: h.object,
        received: c.parsedType
      }), v;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof V && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        i.includes(c) || o.push(c);
    const d = [];
    for (const c of i) {
      const m = s[c], C = a.data[c];
      d.push({
        key: { status: "valid", value: c },
        value: m._parse(new A(a, C, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof V) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const m of o)
          d.push({
            key: { status: "valid", value: m },
            value: { status: "valid", value: a.data[m] }
          });
      else if (c === "strict")
        o.length > 0 && (f(a, {
          code: u.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const m of o) {
        const C = a.data[m];
        d.push({
          key: { status: "valid", value: m },
          value: c._parse(
            new A(a, C, a.path, m)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: m in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const m of d) {
        const C = await m.key, F = await m.value;
        c.push({
          key: C,
          value: F,
          alwaysSet: m.alwaysSet
        });
      }
      return c;
    }).then((c) => T.mergeObjectSync(n, c)) : T.mergeObjectSync(n, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p.errToObj, new k({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, s, i, o;
          const d = (i = (s = (a = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(a, r, n).message) !== null && i !== void 0 ? i : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = p.errToObj(e).message) !== null && o !== void 0 ? o : d
          } : {
            message: d
          };
        }
      } : {}
    });
  }
  strip() {
    return new k({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new k({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new k({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new k({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new k({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return b.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return b.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Y(this);
  }
  partial(e) {
    const r = {};
    return b.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return b.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof N; )
          s = s._def.innerType;
        r[n] = s;
      }
    }), new k({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return $t(b.objectKeys(this.shape));
  }
}
k.create = (t, e) => new k({
  shape: () => t,
  unknownKeys: "strip",
  catchall: V.create(),
  typeName: g.ZodObject,
  ..._(e)
});
k.strictCreate = (t, e) => new k({
  shape: () => t,
  unknownKeys: "strict",
  catchall: V.create(),
  typeName: g.ZodObject,
  ..._(e)
});
k.lazycreate = (t, e) => new k({
  shape: t,
  unknownKeys: "strip",
  catchall: V.create(),
  typeName: g.ZodObject,
  ..._(e)
});
class we extends x {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new R(o.ctx.common.issues));
      return f(r, {
        code: u.invalid_union,
        unionErrors: i
      }), v;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const d of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, m = d._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (m.status === "valid")
          return m;
        m.status === "dirty" && !s && (s = { result: m, ctx: c }), c.common.issues.length && i.push(c.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((d) => new R(d));
      return f(r, {
        code: u.invalid_union,
        unionErrors: o
      }), v;
    }
  }
  get options() {
    return this._def.options;
  }
}
we.create = (t, e) => new we({
  options: t,
  typeName: g.ZodUnion,
  ..._(e)
});
const M = (t) => t instanceof je ? M(t.schema) : t instanceof L ? M(t.innerType()) : t instanceof Ee ? [t.value] : t instanceof G ? t.options : t instanceof Te ? b.objectValues(t.enum) : t instanceof Pe ? M(t._def.innerType) : t instanceof xe ? [void 0] : t instanceof be ? [null] : t instanceof N ? [void 0, ...M(t.unwrap())] : t instanceof B ? [null, ...M(t.unwrap())] : t instanceof Lt || t instanceof Re ? M(t.unwrap()) : t instanceof Se ? M(t._def.innerType) : [];
class at extends x {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.object)
      return f(r, {
        code: u.invalid_type,
        expected: h.object,
        received: r.parsedType
      }), v;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (f(r, {
      code: u.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), v);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = M(s.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new at({
      typeName: g.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ..._(n)
    });
  }
}
function Je(t, e) {
  const r = q(t), n = q(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === h.object && n === h.object) {
    const a = b.objectKeys(e), s = b.objectKeys(t).filter((o) => a.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of s) {
      const d = Je(t[o], e[o]);
      if (!d.valid)
        return { valid: !1 };
      i[o] = d.data;
    }
    return { valid: !0, data: i };
  } else if (r === h.array && n === h.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < t.length; s++) {
      const i = t[s], o = e[s], d = Je(i, o);
      if (!d.valid)
        return { valid: !1 };
      a.push(d.data);
    }
    return { valid: !0, data: a };
  } else return r === h.date && n === h.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ke extends x {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (s, i) => {
      if (xt(s) || xt(i))
        return v;
      const o = Je(s.value, i.value);
      return o.valid ? ((bt(s) || bt(i)) && r.dirty(), { status: r.value, value: o.data }) : (f(n, {
        code: u.invalid_intersection_types
      }), v);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ke.create = (t, e, r) => new ke({
  left: t,
  right: e,
  typeName: g.ZodIntersection,
  ..._(r)
});
class $ extends x {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.array)
      return f(n, {
        code: u.invalid_type,
        expected: h.array,
        received: n.parsedType
      }), v;
    if (n.data.length < this._def.items.length)
      return f(n, {
        code: u.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), v;
    !this._def.rest && n.data.length > this._def.items.length && (f(n, {
      code: u.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const d = this._def.items[o] || this._def.rest;
      return d ? d._parse(new A(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => T.mergeArray(r, i)) : T.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new $({
      ...this._def,
      rest: e
    });
  }
}
$.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new $({
    items: t,
    typeName: g.ZodTuple,
    rest: null,
    ..._(e)
  });
};
class Ce extends x {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.object)
      return f(n, {
        code: u.invalid_type,
        expected: h.object,
        received: n.parsedType
      }), v;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new A(n, o, n.path, o)),
        value: i._parse(new A(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? T.mergeObjectAsync(r, a) : T.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof x ? new Ce({
      keyType: e,
      valueType: r,
      typeName: g.ZodRecord,
      ..._(n)
    }) : new Ce({
      keyType: D.create(),
      valueType: e,
      typeName: g.ZodRecord,
      ..._(r)
    });
  }
}
class Qe extends x {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.map)
      return f(n, {
        code: u.invalid_type,
        expected: h.map,
        received: n.parsedType
      }), v;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, d], c) => ({
      key: a._parse(new A(n, o, n.path, [c, "key"])),
      value: s._parse(new A(n, d, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of i) {
          const c = await d.key, m = await d.value;
          if (c.status === "aborted" || m.status === "aborted")
            return v;
          (c.status === "dirty" || m.status === "dirty") && r.dirty(), o.set(c.value, m.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of i) {
        const c = d.key, m = d.value;
        if (c.status === "aborted" || m.status === "aborted")
          return v;
        (c.status === "dirty" || m.status === "dirty") && r.dirty(), o.set(c.value, m.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Qe.create = (t, e, r) => new Qe({
  valueType: e,
  keyType: t,
  typeName: g.ZodMap,
  ..._(r)
});
class ee extends x {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.set)
      return f(n, {
        code: u.invalid_type,
        expected: h.set,
        received: n.parsedType
      }), v;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (f(n, {
      code: u.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (f(n, {
      code: u.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(d) {
      const c = /* @__PURE__ */ new Set();
      for (const m of d) {
        if (m.status === "aborted")
          return v;
        m.status === "dirty" && r.dirty(), c.add(m.value);
      }
      return { status: r.value, value: c };
    }
    const o = [...n.data.values()].map((d, c) => s._parse(new A(n, d, n.path, c)));
    return n.common.async ? Promise.all(o).then((d) => i(d)) : i(o);
  }
  min(e, r) {
    return new ee({
      ...this._def,
      minSize: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new ee({
      ...this._def,
      maxSize: { value: e, message: p.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ee.create = (t, e) => new ee({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: g.ZodSet,
  ..._(e)
});
class ce extends x {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.function)
      return f(r, {
        code: u.invalid_type,
        expected: h.function,
        received: r.parsedType
      }), v;
    function n(o, d) {
      return Ke({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          We(),
          de
        ].filter((c) => !!c),
        issueData: {
          code: u.invalid_arguments,
          argumentsError: d
        }
      });
    }
    function a(o, d) {
      return Ke({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          We(),
          de
        ].filter((c) => !!c),
        issueData: {
          code: u.invalid_return_type,
          returnTypeError: d
        }
      });
    }
    const s = { errorMap: r.common.contextualErrorMap }, i = r.data;
    if (this._def.returns instanceof le) {
      const o = this;
      return P(async function(...d) {
        const c = new R([]), m = await o._def.args.parseAsync(d, s).catch((re) => {
          throw c.addIssue(n(d, re)), c;
        }), C = await Reflect.apply(i, this, m);
        return await o._def.returns._def.type.parseAsync(C, s).catch((re) => {
          throw c.addIssue(a(C, re)), c;
        });
      });
    } else {
      const o = this;
      return P(function(...d) {
        const c = o._def.args.safeParse(d, s);
        if (!c.success)
          throw new R([n(d, c.error)]);
        const m = Reflect.apply(i, this, c.data), C = o._def.returns.safeParse(m, s);
        if (!C.success)
          throw new R([a(m, C.error)]);
        return C.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ce({
      ...this._def,
      args: $.create(e).rest(H.create())
    });
  }
  returns(e) {
    return new ce({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new ce({
      args: e || $.create([]).rest(H.create()),
      returns: r || H.create(),
      typeName: g.ZodFunction,
      ..._(n)
    });
  }
}
class je extends x {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
je.create = (t, e) => new je({
  getter: t,
  typeName: g.ZodLazy,
  ..._(e)
});
class Ee extends x {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        received: r.data,
        code: u.invalid_literal,
        expected: this._def.value
      }), v;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Ee.create = (t, e) => new Ee({
  value: t,
  typeName: g.ZodLiteral,
  ..._(e)
});
function $t(t, e) {
  return new G({
    values: t,
    typeName: g.ZodEnum,
    ..._(e)
  });
}
class G extends x {
  constructor() {
    super(...arguments), ie.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return f(r, {
        expected: b.joinValues(n),
        received: r.parsedType,
        code: u.invalid_type
      }), v;
    }
    if (_e(this, ie) || At(this, ie, new Set(this._def.values)), !_e(this, ie).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return f(r, {
        received: r.data,
        code: u.invalid_enum_value,
        options: n
      }), v;
    }
    return P(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return G.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return G.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
ie = /* @__PURE__ */ new WeakMap();
G.create = $t;
class Te extends x {
  constructor() {
    super(...arguments), oe.set(this, void 0);
  }
  _parse(e) {
    const r = b.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== h.string && n.parsedType !== h.number) {
      const a = b.objectValues(r);
      return f(n, {
        expected: b.joinValues(a),
        received: n.parsedType,
        code: u.invalid_type
      }), v;
    }
    if (_e(this, oe) || At(this, oe, new Set(b.getValidEnumValues(this._def.values))), !_e(this, oe).has(e.data)) {
      const a = b.objectValues(r);
      return f(n, {
        received: n.data,
        code: u.invalid_enum_value,
        options: a
      }), v;
    }
    return P(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
oe = /* @__PURE__ */ new WeakMap();
Te.create = (t, e) => new Te({
  values: t,
  typeName: g.ZodNativeEnum,
  ..._(e)
});
class le extends x {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.promise && r.common.async === !1)
      return f(r, {
        code: u.invalid_type,
        expected: h.promise,
        received: r.parsedType
      }), v;
    const n = r.parsedType === h.promise ? r.data : Promise.resolve(r.data);
    return P(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
le.create = (t, e) => new le({
  type: t,
  typeName: g.ZodPromise,
  ..._(e)
});
class L extends x {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, s = {
      addIssue: (i) => {
        f(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return v;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return d.status === "aborted" ? v : d.status === "dirty" || r.value === "dirty" ? se(d.value) : d;
        });
      {
        if (r.value === "aborted")
          return v;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? v : o.status === "dirty" || r.value === "dirty" ? se(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const d = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? v : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? v : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!ve(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => ve(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({ status: r.value, value: o })) : i);
    b.assertNever(a);
  }
}
L.create = (t, e, r) => new L({
  schema: t,
  typeName: g.ZodEffects,
  effect: e,
  ..._(r)
});
L.createWithPreprocess = (t, e, r) => new L({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: g.ZodEffects,
  ..._(r)
});
class N extends x {
  _parse(e) {
    return this._getType(e) === h.undefined ? P(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
N.create = (t, e) => new N({
  innerType: t,
  typeName: g.ZodOptional,
  ..._(e)
});
class B extends x {
  _parse(e) {
    return this._getType(e) === h.null ? P(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
B.create = (t, e) => new B({
  innerType: t,
  typeName: g.ZodNullable,
  ..._(e)
});
class Pe extends x {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === h.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Pe.create = (t, e) => new Pe({
  innerType: t,
  typeName: g.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
class Se extends x {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return ye(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new R(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new R(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Se.create = (t, e) => new Se({
  innerType: t,
  typeName: g.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
class Xe extends x {
  _parse(e) {
    if (this._getType(e) !== h.nan) {
      const n = this._getOrReturnCtx(e);
      return f(n, {
        code: u.invalid_type,
        expected: h.nan,
        received: n.parsedType
      }), v;
    }
    return { status: "valid", value: e.data };
  }
}
Xe.create = (t) => new Xe({
  typeName: g.ZodNaN,
  ..._(t)
});
class Lt extends x {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ae extends x {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? v : s.status === "dirty" ? (r.dirty(), se(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? v : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new Ae({
      in: e,
      out: r,
      typeName: g.ZodPipeline
    });
  }
}
class Re extends x {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (ve(a) && (a.value = Object.freeze(a.value)), a);
    return ye(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Re.create = (t, e) => new Re({
  innerType: t,
  typeName: g.ZodReadonly,
  ..._(e)
});
k.lazycreate;
var g;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(g || (g = {}));
const j = D.create;
Q.create;
Xe.create;
X.create;
qe.create;
ue.create;
Ge.create;
xe.create;
be.create;
Ye.create;
H.create;
V.create;
He.create;
I.create;
const _n = k.create;
k.strictCreate;
const xn = we.create;
at.create;
ke.create;
$.create;
Ce.create;
Qe.create;
ee.create;
ce.create;
je.create;
Ee.create;
const kt = G.create;
Te.create;
le.create;
L.create;
N.create;
B.create;
L.createWithPreprocess;
Ae.create;
function bn() {
  function t(e) {
    return Hr(Kr.setUserCurrentProject, {
      method: "POST",
      data: {
        project_id: Number(e)
      }
    });
  }
  return { setUserCurrentProject: t };
}
const wn = Oe`
  mutation UpdateProjectMutation($id: UUID!, $input: ProjectInput!) {
    patchProject(id: $id, input: $input) {
      ...ProjectFragment
    }
  }
  ${O}
`;
function kn() {
  return wr(wn);
}
const Cn = Oe`
  query ProjectsQuery(
    $statuses: [ProjectStatus!]
    $excludedStatuses: [ProjectStatus!]
    $page: Int
    $pageSize: Int
    $sortBy: ProjectSortableField
    $sortDirection: SortDirection
  ) {
    projects(
      statuses: $statuses
      excludedStatuses: $excludedStatuses
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        ...ProjectFragment
      }
      currentPage
    }
  }
  ${O}
`;
function jn(t) {
  return { ...St(Cn, t) };
}
class En extends Error {
}
En.prototype.name = "InvalidTokenError";
function Tn() {
  return Mr("loggedIn");
}
const Pn = "@gensler.com";
function Sn(t) {
  return t?.email ? (t?.email?.toLowerCase()?.trim()).endsWith(Pn) : !1;
}
function Rn() {
  const [t, e] = ze(() => {
    const a = Qr();
    return Vr(a) ? null : Ct(a);
  }), [r, n] = ze(() => t === null);
  return fe(() => {
    function a(s) {
      const i = s.detail.data.customer;
      e(Ct(i)), n(!1);
    }
    return window.addEventListener(yt, a), () => {
      window.removeEventListener(
        yt,
        a
      );
    };
  }, []), {
    isLoading: r,
    customer: t
  };
}
function Ct(t) {
  return {
    ...t,
    isGenslerCustomer: Sn(t)
  };
}
const { Provider: On, useContext: Zt } = Nr();
function In({ children: t }) {
  const { isLoading: e, customer: r } = Rn(), n = nt(() => ({
    isLoading: e,
    customer: r
  }), [e, r]);
  return /* @__PURE__ */ y(On, { value: n, children: t });
}
const Nn = "select-project-timestamp";
function An() {
  localStorage.setItem(Nn, String(Date.now()));
}
function Mn(t) {
  window.dispatchEvent(
    new CustomEvent(Rr, {
      detail: { projectId: t }
    })
  );
}
function Ut() {
  const { customer: t } = Zt(), { setUserCurrentProject: e } = bn(), { currentProjectId: r, setCurrentProject: n } = Dn();
  fe(() => {
    r || n(t?.current_project ?? null);
  }, [r, t?.current_project, n]);
  async function a(s, i) {
    if (!s)
      return;
    const o = r;
    n(s);
    try {
      if ((await e(s))?.data?.status !== "success") {
        n(o);
        return;
      }
      An(), Mn(s), en();
    } catch (d) {
      n(o), i?.(d);
    }
  }
  return {
    currentExternalProjectId: r,
    setCurrentProjectId: a
  };
}
const jt = Oe`
  query GetCurrentProject {
    currentProjectId @client
  }
`;
function Dn() {
  const t = Ie(), { data: e, refetch: r } = St(jt);
  function n(a) {
    t.writeQuery({
      query: jt,
      data: {
        currentProjectId: a
      },
      overwrite: !0
    }), r();
  }
  return {
    currentProjectId: e?.currentProjectId,
    setCurrentProject: n
  };
}
const et = {
  openProjectEditDialogEvent: "project-edit-dialog-open-event",
  projectEditDialogProjectUpdatedEvent: "project-edit-dialog-project-updated-event"
};
function Vt(t) {
  window.dispatchEvent(
    new CustomEvent(
      et.openProjectEditDialogEvent,
      {
        detail: t
      }
    )
  );
}
function $n({
  children: t,
  ...e
}) {
  return /* @__PURE__ */ y(
    Cr,
    {
      componentsProps: {
        tooltip: {
          sx: {
            backgroundColor: "primary.main",
            borderRadius: "50px"
          }
        }
      },
      ...e,
      children: t
    }
  );
}
function Ln() {
  return /* @__PURE__ */ y(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ y(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53267 7.63325C7.77675 7.38918 8.17247 7.38918 8.41655 7.63325L11.9746 11.1913L15.5327 7.63325C15.7767 7.38918 16.1725 7.38918 16.4166 7.63325C16.6606 7.87733 16.6606 8.27306 16.4166 8.51714L12.8585 12.0752L16.4166 15.6333C16.6606 15.8773 16.6606 16.2731 16.4166 16.5171C16.1725 16.7612 15.7767 16.7612 15.5327 16.5171L11.9746 12.9591L8.41655 16.5171C8.17247 16.7612 7.77675 16.7612 7.53267 16.5171C7.28859 16.2731 7.28859 15.8773 7.53267 15.6333L11.0907 12.0752L7.53267 8.51714C7.28859 8.27306 7.28859 7.87733 7.53267 7.63325Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Zn() {
  return /* @__PURE__ */ y(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ y(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4.625C7.9269 4.625 4.625 7.9269 4.625 12C4.625 16.0731 7.9269 19.375 12 19.375C16.0731 19.375 19.375 16.0731 19.375 12C19.375 7.9269 16.0731 4.625 12 4.625ZM3.375 12C3.375 7.23654 7.23654 3.375 12 3.375C16.7635 3.375 20.625 7.23654 20.625 12C20.625 16.7635 16.7635 20.625 12 20.625C7.23654 20.625 3.375 16.7635 3.375 12ZM12.0001 6.6608C12.3453 6.6608 12.6251 6.94062 12.6251 7.2858V8.22845C12.6251 8.57363 12.3453 8.85345 12.0001 8.85345C11.6549 8.85345 11.3751 8.57363 11.3751 8.22845V7.2858C11.3751 6.94062 11.6549 6.6608 12.0001 6.6608ZM12.0001 10.4328C12.3453 10.4328 12.6251 10.7126 12.6251 11.0578V16.7138C12.6251 17.0589 12.3453 17.3388 12.0001 17.3388C11.6549 17.3388 11.3751 17.0589 11.3751 16.7138V11.0578C11.3751 10.7126 11.6549 10.4328 12.0001 10.4328Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Un() {
  return /* @__PURE__ */ U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "currentColor",
      children: [
        /* @__PURE__ */ y("circle", { cx: "32", cy: "32", r: "24" }),
        /* @__PURE__ */ y("line", { x1: "32", y1: "16", x2: "32", y2: "36" }),
        /* @__PURE__ */ y("line", { x1: "32", y1: "44", x2: "32", y2: "48" })
      ]
    }
  );
}
const Vn = Tt.createContext(null), Bn = () => Tt.useContext(Vn);
function Fn(t) {
  return /^[-\s]/.test(t);
}
function zn(t) {
  return /[\[\](){}]/.test(t);
}
function Wn(t) {
  return /[@#$%^&*]/.test(t);
}
function Kn(t) {
  return /[+=|\\]/.test(t);
}
function qn(t) {
  return /[:;"<>,?]/.test(t);
}
function Gn(t) {
  return /[!~`]/.test(t);
}
const Et = 500, Yn = 20, tt = It === "US";
function Hn(t, e) {
  if (!t)
    return !1;
  const r = t.toLowerCase();
  return e.map(
    (a) => new RegExp(`\\b${a.toLowerCase()}\\b`, "gi")
  ).some((a) => a.test(r));
}
const Bt = (t, e) => {
  const r = e === Nt.TIER_13_GROUP_ID;
  return _n({
    name: j().min(1, "Project name is required").refine((n) => !Fn(n), "Project names cannot start with a hyphen or space.").refine((n) => !zn(n), "Project names cannot include brackets: [ ] ( ) { }").refine((n) => !Wn(n), "Project names cannot include special characters: @ # $ % ^ & *").refine((n) => !Kn(n), "Project names cannot include special characters: + = | \\").refine((n) => !qn(n), "Project names cannot include special characters: ? : ; ” < > ,").refine((n) => !Gn(n), "Project names cannot include special characters: ! ~ `").refine((n) => !Hn(n, t), "Please enter a valid Project name."),
    country: j().min(1, "Country is required"),
    city: r ? j().nullable().optional() : j().min(1, "Please add city to your project"),
    state: r ? j().nullable().optional() : j().min(1, "State is required"),
    type: j().min(1, "Type is required"),
    phase: r ? j().nullable().optional() : j().min(1, "Phase is required"),
    size: r ? j().nullable().optional() : j().min(1, "Size is required"),
    budget: r ? j().nullable().optional() : j().min(1, "Budget is required"),
    dueMonth: r ? xn([
      kt(Object.values(E)),
      j()
    ]).nullable().optional() : kt(Object.values(E), {
      errorMap: () => ({ message: "Select correct month and year" })
    }),
    dueYear: r ? j().nullable().optional() : j().min(1, "Select correct month and year"),
    description: r ? j().nullable().optional() : j().min(
      Yn,
      "Please provide more information about your project"
    ).max(
      Et,
      `Description must be at most ${Et} characters`
    ).refine(
      (n) => n.trim().length > 1,
      "Please provide more information about your project"
    )
  });
}, Jn = (t, e) => Bt(t, e).omit({
  state: !0
}), Qn = (t, e) => {
  const r = tt ? Bt(t, e) : Jn(t, e);
  return Object.keys(r.shape).filter((n) => {
    const a = r.shape[n];
    return !(a instanceof N || a instanceof B);
  });
}, Xn = {
  name: "title",
  country: "country",
  state: "state",
  city: "city",
  type: "type",
  phase: "phase",
  size: "size",
  budget: "budget",
  dueMonth: "dueMonth",
  dueYear: "dueYear",
  description: "details"
}, ea = ["size", "budget"];
E.January + "", E.February + "", E.March + "", E.April + "", E.May + "", E.June + "", E.July + "", E.August + "", E.September + "", E.October + "", E.November + "", E.December + "", E.NotSure + "";
const Me = Bn;
rt(
  {}
);
function ta() {
  return /* @__PURE__ */ y("div", { className: "text-red flex-shrink-0", children: /* @__PURE__ */ y(Un, {}) });
}
const Ft = te(
  (t, e) => {
    const r = `py-0 px-4 text-gray ${t.InputProps?.endAdornment ? "pr-10" : ""}`;
    return /* @__PURE__ */ y(
      jr,
      {
        ...t,
        ref: e,
        className: "h-9 md:h-12 rounded-full py-0 bg-[#F5F5F7] focus:border-[#B9C8F4] focus:outline-none",
        variant: "outlined",
        InputProps: {
          ...t.InputProps,
          classes: {
            notchedOutline: t.error ? "" : "border-none",
            input: r
          },
          className: "h-9 md:h-12 rounded-full p-0"
        }
      }
    );
  }
);
Ft.displayName = "TextField";
const ra = te(
  ({ initialValue: t, onClear: e, ...r }, n) => {
    const { setValue: a } = Me(), [s, i] = ze(t ?? "");
    fe(() => {
      t && i(t);
    }, [t]);
    function o(c) {
      i(c.target.value), r.onChange && r.onChange(c);
    }
    function d() {
      i(""), r.onChange && r.onChange({
        target: { value: "" }
      }), a(r.name, ""), e?.();
    }
    return /* @__PURE__ */ y(
      Ft,
      {
        ...r,
        ref: n,
        value: s,
        InputProps: {
          ...r.InputProps,
          endAdornment: s ? /* @__PURE__ */ y(Er, { position: "end", className: "absolute right-5", children: /* @__PURE__ */ y(Rt, { edge: "end", tabIndex: -1, onClick: d, children: /* @__PURE__ */ y(Ln, {}) }) }) : null
        },
        onChange: o
      }
    );
  }
);
ra.displayName = "Input";
const st = "unknown", na = [
  { label: "10M+", from: 1e7, to: null },
  { label: "1M - 10M", from: 1e6, to: 1e7 },
  { label: "500K - 1M", from: 5e5, to: 1e6 },
  { label: "250K - 500K", from: 25e4, to: 5e5 },
  { label: "100K - 250K", from: 1e5, to: 25e4 },
  { label: "0 - 100K", from: 0, to: 1e5 },
  { label: "Unsure", value: st }
];
zt(
  na
);
const aa = [
  { label: "500K+", from: 5e5 },
  { label: "100K - 500K", from: 1e5, to: 5e5 },
  { label: "50K - 100K", from: 5e4, to: 1e5 },
  { label: "20K - 50K", from: 2e4, to: 5e4 },
  { label: "5K - 20K", from: 5e3, to: 2e4 },
  { label: "0 - 5K", from: 0, to: 5e3 },
  { label: "Unsure", value: st }
], sa = [
  { label: "50,000+", from: 5e4 },
  { label: "10,000 - 50,000", from: 1e4, to: 5e4 },
  { label: "5,000 - 10,000", from: 5e3, to: 1e4 },
  { label: "2,000 - 5,000", from: 2e3, to: 5e3 },
  { label: "500 - 2,000", from: 500, to: 2e3 },
  { label: "0 - 500", from: 0, to: 500 },
  { label: "Unsure", value: st }
], ia = It === "EU" ? sa : aa;
zt(ia);
function zt(t) {
  return t.map((e) => {
    const { label: r, from: n, to: a, value: s, ...i } = e;
    return s ? { ...e, value: `${e.value}` } : {
      label: r,
      value: `${n}-${a}`,
      from: n,
      to: a,
      ...i
    };
  });
}
const oa = te(
  ({ field: t, type: e, label: r, value: n, isSelected: a, onChangeAnalyticsCallback: s }, i) => {
    const { t: o } = Ne(), { register: d } = Me(), c = d(t);
    return /* @__PURE__ */ U("label", { ref: i, className: "flex items-center mb-0", tabIndex: 0, children: [
      /* @__PURE__ */ y(
        "input",
        {
          type: e,
          id: `${t}-${n}`,
          value: n,
          ...c,
          onChange: (m) => {
            c.onChange(m), s?.(r, n);
          },
          className: "hidden"
        }
      ),
      /* @__PURE__ */ y(
        "span",
        {
          className: `px-3 py-1.5 md:px-4 md:py-3 border-none rounded-full cursor-pointer ${a ? "bg-[#4D4E58] text-white" : "hover:bg-gray-200 bg-[#F5F5F6]"}`,
          children: o(r)
        }
      )
    ] });
  }
);
oa.displayName = "OptionInput";
const J = te(
  ({
    field: t,
    type: e,
    label: r = "",
    infoText: n,
    hasError: a,
    withLabel: s = !0,
    withDivider: i = !0,
    withPlaceholder: o = !1,
    children: d
  }, c) => /* @__PURE__ */ U(
    "div",
    {
      ref: c,
      className: "flex flex-col gap-3 transition-all duration-300 ease-in-out",
      children: [
        /* @__PURE__ */ y(
          Wt,
          {
            field: t,
            fieldInfoType: "inline",
            type: e,
            hasError: a,
            withLabel: s,
            infoText: n,
            label: r,
            withDivider: i,
            withPlaceholder: o
          }
        ),
        d
      ]
    },
    t
  )
);
function Wt({
  field: t,
  label: e,
  withLabel: r,
  hasError: n,
  withDivider: a,
  withPlaceholder: s,
  fieldInfoType: i,
  type: o,
  infoText: d
}) {
  const { t: c } = Ne();
  return r ? /* @__PURE__ */ U("div", { className: "flex items-center gap-2 min-w-0 overflow-hidden", children: [
    /* @__PURE__ */ y(
      Tr,
      {
        htmlFor: t,
        className: "text-base md:text-md font-semibold text-gray-700 mb-0 truncate min-w-0 flex-shrink-0",
        style: { maxWidth: "80%" },
        title: e ? c(e) : void 0,
        children: e ? c(e) : null
      }
    ),
    i === "inline" && d ? /* @__PURE__ */ y(
      gt,
      {
        variant: "caption",
        className: "text-gray-500 truncate block min-w-0",
        title: c(d),
        children: `(${c(d)})`
      }
    ) : null,
    o === "multiValue" ? /* @__PURE__ */ y(
      gt,
      {
        variant: "caption",
        className: "text-gray-500 truncate block min-w-0",
        title: c("Select all that apply"),
        children: `(${c("Select all that apply")})`
      }
    ) : null,
    i === "tooltip" && d ? /* @__PURE__ */ y(
      $n,
      {
        title: c(d),
        PopperProps: ca,
        placement: "right-end",
        className: "p-0 hidden md:block flex-shrink-0",
        children: /* @__PURE__ */ y(Rt, { children: /* @__PURE__ */ y(Zn, {}) })
      }
    ) : null,
    n ? /* @__PURE__ */ y(ta, {}) : null
  ] }) : a ? /* @__PURE__ */ y(Pr, {}) : s ? /* @__PURE__ */ y("div", { style: { height: "32px" } }) : null;
}
const ca = {
  sx: {
    zIndex: 999999943
  }
};
J.displayName = "FormField";
const da = "singleValue", ua = "singleValue", la = "singleValue", fa = te(
  ({ fieldRefs: t, index: e, cityComponent: r, stateComponent: n, countryComponent: a }, s) => {
    const { t: i } = Ne(), d = Me()?.formState?.errors ?? {};
    return /* @__PURE__ */ U(
      "div",
      {
        ref: (c) => {
          t.current[e] = c, typeof s == "function" ? s(c) : s && (s.current = c);
        },
        className: "flex flex-col w-full gap-4",
        children: [
          /* @__PURE__ */ U("div", { className: "flex flex-row w-full", children: [
            /* @__PURE__ */ y("div", { className: tt ? "w-1/2 pr-2" : "w-full", children: /* @__PURE__ */ y(
              J,
              {
                field: "city",
                label: i("Location"),
                type: da,
                withLabel: !0,
                hasError: !!d?.city || !!d?.state || !!d?.country,
                children: r
              }
            ) }),
            tt ? /* @__PURE__ */ y("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ y(
              J,
              {
                field: "state",
                withLabel: !1,
                withDivider: !1,
                withPlaceholder: !0,
                type: ua,
                children: n
              }
            ) }) : null
          ] }),
          /* @__PURE__ */ y("div", { className: "w-full", children: /* @__PURE__ */ y(
            J,
            {
              field: "country",
              withLabel: !1,
              withDivider: !1,
              withPlaceholder: !1,
              type: la,
              children: a
            }
          ) })
        ]
      }
    );
  }
);
fa.displayName = "Location";
const ha = "singleValue", pa = "singleValue", ma = te(
  ({ fieldRefs: t, index: e, monthComponent: r, yearComponent: n, readonly: a = !1 }, s) => {
    const { t: i } = Ne(), d = Me()?.formState?.errors ?? {};
    return /* @__PURE__ */ U(
      "div",
      {
        ref: (c) => {
          t.current[e] = c, typeof s == "function" ? s(c) : s && (s.current = c);
        },
        className: "flex flex-col w-full gap-3",
        children: [
          /* @__PURE__ */ y("div", { className: "flex flex-row w-full", children: /* @__PURE__ */ y(
            Wt,
            {
              type: "singleValue",
              label: i("Estimated completion date"),
              infoText: i("Project end date"),
              fieldInfoType: "inline",
              withLabel: !0,
              hasError: !!d?.dueMonth || !!d?.dueYear
            }
          ) }),
          /* @__PURE__ */ y(
            "div",
            {
              className: `flex flex-col gap-1 md:gap-4 relative ${a ? "" : "min-h-[80px] md:min-h-[112px]"}`,
              children: /* @__PURE__ */ U("div", { className: "flex flex-row w-full", children: [
                /* @__PURE__ */ y("div", { className: "w-1/2 pr-2", children: /* @__PURE__ */ y(
                  J,
                  {
                    field: "dueMonth",
                    type: ha,
                    withLabel: !1,
                    withDivider: !1,
                    children: r
                  }
                ) }),
                /* @__PURE__ */ y("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ y(
                  J,
                  {
                    field: "dueYear",
                    type: pa,
                    withLabel: !1,
                    withDivider: !1,
                    children: n
                  }
                ) })
              ] })
            }
          )
        ]
      }
    );
  }
);
ma.displayName = "Timeline";
const Kt = (/* @__PURE__ */ new Date()).getFullYear();
Kt.toString();
(/* @__PURE__ */ new Date()).getMonth();
ga();
function ga() {
  return Array.from({ length: 6 }, (t, e) => {
    const r = (Kt + e).toString();
    return { label: r, value: r };
  });
}
const va = {
  AL: "Alabama",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}, ya = [
  { code: "AB", name: "Alberta", value: "66" },
  { code: "BC", name: "British Columbia", value: "67" },
  { code: "MB", name: "Manitoba", value: "68" },
  { code: "NL", name: "Newfoundland and Labrador", value: "69" },
  { code: "NB", name: "New Brunswick", value: "70" },
  { code: "NS", name: "Nova Scotia", value: "71" },
  { code: "NT", name: "Northwest Territories", value: "72" },
  { code: "NU", name: "Nunavut", value: "73" },
  { code: "ON", name: "Ontario", value: "74" },
  { code: "PE", name: "Prince Edward Island", value: "75" },
  { code: "QC", name: "Quebec", value: "76" },
  { code: "SK", name: "Saskatchewan", value: "77" },
  { code: "YT", name: "Yukon Territory", value: "78" }
], _a = {
  AD: "Andorra",
  AT: "Austria",
  BE: "Belgium",
  BG: "Bulgaria",
  HR: "Croatia",
  CZ: "Czechia",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IE: "Ireland",
  IT: "Italy",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MC: "Monaco",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  SE: "Sweden",
  CH: "Switzerland",
  GB: "United Kingdom",
  IL: "Israel",
  SA: "Saudi Arabia",
  AE: "United Arab Emirates",
  TR: "Turkey",
  KW: "Kuwait",
  QA: "Qatar",
  BH: "Bahrain",
  US: "United States",
  MT: "Malta",
  NO: "Norway"
}, xa = {
  CA: "Canada",
  US: "United States"
};
Object.entries(_a).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(xa).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(va).map(([t, e]) => ({
  label: e,
  value: e
}));
ya.map(({ name: t }) => ({
  label: t,
  value: t
}));
function ba(t, e) {
  return !t || !e ? !1 : t.userRef === e?.customer_id;
}
function wa() {
  const { customer: t } = Zt();
  function e(n) {
    return n ? ka(n, t?.groupId ?? null) : !1;
  }
  function r(n) {
    return ba(n, t);
  }
  return { isProjectDataComplete: e, isProjectEditable: r };
}
function ka(t, e) {
  return Qn(
    [],
    e
  ).filter(
    (n) => !ea.includes(
      n
    )
  ).every((n) => {
    const a = Xn[n];
    return !!t[a];
  });
}
const Ca = 1e9;
function ja({ variables: t, options: e } = {
  variables: {},
  options: {}
}) {
  return jn({
    variables: {
      page: 1,
      pageSize: Ca,
      sortDirection: Ot.Asc,
      ...t
    },
    fetchPolicy: "cache-first",
    ...e
  });
}
function Ea(t) {
  const {
    data: e,
    loading: r,
    error: n,
    refetch: a
  } = ja({
    options: {
      skip: !t
    }
  }), { projects: s, activeProjects: i } = nt(() => {
    const o = {}, d = {};
    return e?.projects.items.forEach((c) => {
      o[c.externalId] = c, c.status === Z.Active && (d[c.externalId] = c);
    }), {
      projects: o,
      activeProjects: d
    };
  }, [e?.projects.items]);
  return { loading: r, projects: s, activeProjects: i, error: n, refetch: a };
}
const qt = rt({});
function Ta({
  shouldFetch: t = !0,
  children: e
}) {
  const { loading: r, projects: n, activeProjects: a, error: s, refetch: i } = Ea(t), { setCurrentProjectId: o } = Ut(), { isProjectDataComplete: d } = wa(), c = nt(() => {
    function m(C) {
      const F = n[C];
      if (F) {
        if (!d(F)) {
          Vt({
            projectId: Number(C),
            successCallback: () => {
              o(C);
            }
          });
          return;
        }
        o(C);
      }
    }
    return {
      projects: n,
      projectsLoading: r,
      projectsError: s,
      refetch: i,
      setCurrentProject: m,
      activeProjects: a
    };
  }, [
    n,
    a,
    r,
    s,
    i,
    d,
    o
  ]);
  return /* @__PURE__ */ y(qt.Provider, { value: c, children: e });
}
function Pa() {
  const t = Pt(qt);
  if (!t)
    throw new Error(
      "useProjectsProvider must be used within a ProjectsProvider"
    );
  return t;
}
function Za() {
  const { currentExternalProjectId: t, setCurrentProjectId: e } = Ut(), { projects: r, projectsLoading: n } = Pa();
  return {
    currentProject: t ? r[t] : null,
    loading: n,
    setCurrentProjectId: e
  };
}
function Ua() {
  function t(e) {
    Vt({
      projectId: e
    });
  }
  return { onEdit: t };
}
function Va() {
  const t = Ie();
  fe(() => {
    async function e(r) {
      const { detail: n } = r;
      if (!n || !n?.project)
        return;
      const a = n.project;
      t.cache.readFragment({
        id: `Project:${a.id}`,
        fragment: O
      }) || (t.cache.writeFragment({
        id: `Project:${a.id}`,
        fragment: O,
        data: a
      }), t.cache.modify({
        fields: {
          projects(i = { items: [] }) {
            const o = t.cache.writeFragment({
              data: a,
              fragment: O
            });
            return {
              ...i,
              items: [o, ...i.items]
            };
          }
        }
      }));
    }
    return window.addEventListener(
      ge.projectCreateDialogProjectCreatedEvent,
      e
    ), () => {
      window.removeEventListener(
        ge.projectCreateDialogProjectCreatedEvent,
        e
      );
    };
  }, [t]);
}
function Ba() {
  const t = Ie();
  fe(() => {
    async function e(r) {
      const { detail: n } = r;
      if (!n || !n?.project)
        return;
      const a = n.project, s = t.cache.readFragment({
        id: `Project:${a.id}`,
        fragment: O
      });
      s && s.updatedAt === a.updatedAt || (t.cache.writeFragment({
        id: `Project:${a.id}`,
        fragment: O,
        data: a
      }), t.cache.modify({
        fields: {
          projects(i = { items: [] }) {
            const o = t.cache.writeFragment({
              data: a,
              fragment: O
            });
            return {
              ...i,
              items: i.items.map(
                (d) => d.__ref === `Project:${a.id}` ? o : d
              )
            };
          }
        }
      }));
    }
    return window.addEventListener(
      et.projectEditDialogProjectUpdatedEvent,
      e
    ), () => {
      window.removeEventListener(
        et.projectEditDialogProjectUpdatedEvent,
        e
      );
    };
  }, [t]);
}
function Fa() {
  const t = Ie(), [e, { loading: r }] = kn();
  function n(a, s, i) {
    const o = t.readFragment({
      id: `Project:${a.id}`,
      fragment: O
    });
    return e({
      variables: a,
      optimisticResponse: {
        patchProject: {
          __typename: "Project",
          ...o,
          ...s
        }
      },
      update: (d, { data: c }) => {
        if (!c)
          return;
        const m = c.patchProject;
        d.writeFragment({
          id: `Project:${m.id}`,
          fragment: O,
          data: m
        });
      },
      onError: (d) => {
        console.error(d), i?.(d);
      }
    });
  }
  return { loading: r, updateProject: n };
}
function za({ children: t }) {
  const e = !!Tn();
  return /* @__PURE__ */ y(In, { children: /* @__PURE__ */ y(Ta, { shouldFetch: e, children: t }) });
}
function Wa(t) {
  return t.status === Z.Archived;
}
const Ka = {
  [Z.Active]: "#7DC64E",
  [Z.OnHold]: "#D18023",
  [Z.Completed]: "#425270",
  [Z.Canceled]: "#DE6CAF",
  [Z.Archived]: "#CECECE"
};
export {
  za as ProjectsCustomerProvider,
  Ta as ProjectsProvider,
  Mn as dispatchSetCurrentProjectId,
  Wa as isProjectArchived,
  ba as isProjectEditable,
  Da as projectCreatedEvent,
  Ka as projectStatusColorMap,
  Or as projectsAnalyticsSelectors,
  Rr as setCurrentProjectIdEvent,
  $a as useCreateProjectButtonAnalyticsIdentifier,
  La as useCreateProjectDialog,
  Za as useCurrentProject,
  Ut as useCurrentProjectId,
  Dn as useCurrentProjectIdFromCache,
  Ua as useEditProjectDialog,
  Fa as useProjectUpdate,
  Va as useProjectsCreatedListener,
  Pa as useProjectsProvider,
  ja as useProjectsQueryNoPagination,
  Ba as useProjectsUpdatedListener,
  wa as useValidateProjectData
};
